import { render, staticRenderFns } from "./TCGAboxplotModal.vue?vue&type=template&id=496bd95e&scoped=true&"
import script from "./TCGAboxplotModal.vue?vue&type=script&lang=js&"
export * from "./TCGAboxplotModal.vue?vue&type=script&lang=js&"
import style0 from "./TCGAboxplotModal.vue?vue&type=style&index=0&id=496bd95e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496bd95e",
  null
  
)

export default component.exports